import React from 'react';
import SalesReportaHeader from '../SalesReportaHeader';
import SalesReportaContent from '../SalesReportaContent';

const SalesReporta = () => {
    return (
        <>
            <SalesReportaHeader />
            <SalesReportaContent />
        </>
    );
};

export default SalesReporta;
